export const calculateMaxFeasibilityDays = (offer) =>
  Number(offer.feasibility_period ?? 0) +
  Number(offer.number_of_feasibility_extensions ?? 0) *
    Number(offer.days_in_each_feasibility_extension ?? 0);
export const calculateMaxZoningDays = (offer) =>
  Number(offer.zoning_approval_period ?? 0) +
  Number(offer.number_of_zoning_extensions ?? 0) *
    Number(offer.days_in_each_zoning_extension ?? 0);
export const calculateMaxClosingDays = (offer) =>
  Number(offer.closing_period ?? 0) +
  Number(offer.number_of_closing_extensions ?? 0) *
    Number(offer.days_in_each_closing_extension ?? 0);
export const calculateMaxDealDuration = (offer) =>
  calculateMaxFeasibilityDays(offer) +
  calculateMaxZoningDays(offer) +
  calculateMaxClosingDays(offer);
